<template>
    <div class="testPage">
        <video src="../../assets/video/bg_home_g.mp4" autoPlay muted="true" loop="true" class="video"></video>
        <div class="t-content" :style="{ 'margin-left': marginLeft + 'px' }">
            <p class="top-title">{{ nowInfo.name }}</p>
            <p class="top-second-title"><span>*</span> {{ nowInfo.message }}</p>
            <el-form ref="form" :model="form" class="question-form">
                <el-form-item v-for="(item, index) in form.list" :key="item.id">
                    <div class="question-item">
                        <p class="q-i-question">
                            {{ index + 1 + '、' + item.question }}
                            <el-tooltip effect="dark" placement="right">
                                <div slot="content" style="width: 227px; font-size: 14px;">
                                    {{ item.indicatorMeaning }}
                                </div>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <!-- 类型1的题目 -->
                        <el-form-item v-if="item.calculationMethod === '1'" class="baseInput">
                            <!-- 1 -->
                            <el-form-item>
                                <el-select v-model="item.answer" disabled>
                                    <el-option v-for="item in item.calculationValue" :key="item.value" :label="item.value"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item class="des-input" v-show="item.answer === '有'">
                                <el-input type="textarea" :rows="3" v-model="item.answerExplain" disabled></el-input>
                            </el-form-item>
                        </el-form-item>
                        <!-- 类型2的题目 -->
                        <el-form-item v-if="item.calculationMethod === '2' && item.fourthIndicatorName !== '股东大会参与度' && item.fourthIndicatorName !== '董事会出席情况' && item.fourthIndicatorName !== '董事亲属关系情况'">
                            <el-form-item>
                                <!-- 2 -->
                                <el-input v-model="item.answer" class="input" disabled></el-input>
                            </el-form-item>
                            <el-form-item class="des-input" v-show="item.answer !== '无'">
                                <el-input type="textarea" :rows="3" v-model="item.answerExplain"></el-input>
                            </el-form-item>
                        </el-form-item>
                        <!-- 类型3的题目 -->
                        <el-form-item prop="answer" v-if="item.calculationMethod === '3'">
                            <!-- 3 -->
                            <div class="more-input">
                                <el-form-item>
                                    <el-autocomplete class="input" v-model="item.answer" placeholder="请输入内容" disabled />
                                </el-form-item>
                                <el-form-item class="one-select">
                                    <el-select v-model="item.answerFinalUnit" disabled>
                                        <el-option v-for="item in item.calculationValue" :key="item.value"
                                            :label="item.value" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item class="des-input" v-show="item.answer !== '无' && item.answer !== null">
                                <el-input type="textarea" :rows="3" v-model="item.answerExplain" disabled></el-input>
                            </el-form-item>
                        </el-form-item>
                        <!-- 类型5的题目 -->
                        <el-form-item v-if="item.calculationMethod === '5'">
                            <!-- 5 -->
                            <el-cascader v-model="item.answer" :options="item.options" style="width: 354px;"
                                disabled></el-cascader>
                        </el-form-item>
                        <!-- 类型7的题目 -->
                        <el-form-item v-if="item.calculationMethod === '7' && item.fourthIndicatorName !== '实控人控制层级'">
                            <!-- 7 -->
                            <div class="more-input">
                                <el-form-item>
                                    <el-autocomplete class="input" v-model="item.answer" placeholder="请输入内容" disabled />
                                </el-form-item>
                                <el-form-item class="one-select">
                                    <el-select v-model="item.answerFinalUnit" disabled>
                                        <el-option v-for="item in item.calculationValue" :key="item.value"
                                            :label="item.value" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item class="two-select">
                                    <el-select v-model="item.answerDataSourceValue" disabled>
                                        <el-option v-for="item in item.dataSourceValue" :key="item.value"
                                            :label="item.value" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item class="des-input" v-show="item.answer !== '无' && item.answer !== null">
                                <el-input type="textarea" :rows="3" v-model="item.answerExplain" disabled></el-input>
                            </el-form-item>
                        </el-form-item>
                        <!-- 类型12的题目 -->
                        <el-form-item v-if="item.calculationMethod === '12'">
                            <!-- 12 -->
                            <el-select v-model="item.answer" disabled>
                                <el-option v-for="item in item.calculationValue" :key="item.value" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 类型5的题目 -->
                        <el-form-item v-if="item.calculationMethod === '5'">
                            <!-- 5 -->
                            <el-cascader v-model="item.answer" :options="item.options" style="width: 354px;" disabled>
                            </el-cascader>
                        </el-form-item>
                        <!-- 实控人控制层级 -->
                        <el-form-item v-if="item.fourthIndicatorName === '实控人控制层级'" :prop="'list.' + index + '.answer'">
                            <el-button type="primary" size="medium" @click="actualControllerDialogVisible = true"
                                :disabled="actualControllerChecked">查看</el-button>
                            <el-checkbox v-model="actualControllerChecked" style="margin-left: 10px;"
                                disabled>无</el-checkbox>
                        </el-form-item>
                        <!-- 股东大会参与度 -->
                        <el-form-item v-if="item.fourthIndicatorName === '股东大会参与度'" :prop="'list.' + index + '.answer'">
                            <el-button type="primary" size="medium" @click="shareholderDialogVisible = true"
                                :disabled="shareholderChecked">查看</el-button>
                            <el-checkbox v-model="shareholderChecked" style="margin-left: 10px;" disabled>无</el-checkbox>
                        </el-form-item>
                        <!-- 董事会出席情况 -->
                        <el-form-item v-if="item.fourthIndicatorName === '董事会出席情况'" :prop="'list.' + index + '.answer'">
                            <el-button type="primary" size="medium" @click="directorateDialogVisible = true"
                                :disabled="directorateChecked">查看</el-button>
                            <el-checkbox v-model="directorateChecked" style="margin-left: 10px;" disabled>无</el-checkbox>
                        </el-form-item>
                        <!-- 董事亲属关系情况 -->
                        <el-form-item v-if="item.fourthIndicatorName === '董事亲属关系情况'" 
                        :prop="'list.' + index + '.answer'">
                            <el-button type="primary" size="medium" @click="kinshipDialogVisible = true"
                                :disabled="kinshipChecked">查看</el-button>
                            <el-checkbox v-model="kinshipChecked" style="margin-left: 10px;" disabled>无</el-checkbox>
                        </el-form-item>
                    </div>
                </el-form-item>
                <div style="text-align: center;">
                    <div class="footer">
                        <el-button class="bottom-btn" @click="toFirstPage">返回首页</el-button>
                        <!-- <el-button class="bottom-btn">上一页</el-button>
                        <el-button class="bottom-btn">下一页</el-button> -->
                    </div>
                </div>
            </el-form>

            <el-dialog title="实控人控制层级" :visible.sync="actualControllerDialogVisible" width="50%">
                <el-table :data="actualControllerTableData" style="width: 100%">
                    <el-table-column type="index" label="层级序号" width="80" align="center">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="控股企业">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shareholdingRation" label="持股比例（%）">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.shareholdingRation" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="controlledCompany" label="被控股企业">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.controlledCompany" disabled></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="actualControllerDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <el-dialog title="股东大会参与度" :visible.sync="shareholderDialogVisible" width="60%">
                <el-select v-model="shareholderFlag" disabled>
                    <el-option key="1" label="按董事人员统计" value="1">
                    </el-option>
                    <el-option key="2" label="按会议次数计算" value="2">
                    </el-option>
                </el-select>
                <!-- 按董事人员统计 -->
                <el-table :data="shareholderTableData" style="width: 100%" v-if="shareholderFlag == 1">
                    <el-table-column prop="directorName" label="董事姓名">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.directorName" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attendance" label="应出席股东会次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.attendance" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualAttendance" label="实际出席股东会次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.actualAttendance" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="others" label="其他">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.others" disabled></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 按会议次数计算 -->
                <el-table :data="shareholderTableData2" style="width: 100%" v-if="shareholderFlag == 2">
                    <el-table-column prop="meetingName" label="股东会决议名称">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.meetingName" clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="directorsAttend" label="应参加董事人数">
                        <template slot-scope="scope">
                            <el-input v-model.number="scope.row.directorsAttend" disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="directorsActualAttend" label="实际出席董事人数">
                        <template slot-scope="scope">
                            <el-input v-model.number="scope.row.directorsActualAttend" disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="others" label="其他">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.others" disabled>
                                <el-option key="1" label="部分参加" value="1">
                                </el-option>
                                <el-option key="2" label="全部参加" value="2">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="originalInformation" label="原始信息">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.originalInformation" disabled></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="shareholderDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <el-dialog title="董事会出席情况" :visible.sync="directorateDialogVisible" width="80%">
                <el-select v-model="directorateFlag" disabled>
                    <el-option key="1" label="按董事人员统计" value="1">
                    </el-option>
                    <el-option key="2" label="按会议次数计算" value="2">
                    </el-option>
                </el-select>
                <!-- 按董事人员统计 -->
                <el-table :data="directorateTableData" style="width: 100%" v-if="directorateFlag == 1">
                    <el-table-column prop="directorName" label="董事姓名">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.directorName" placeholder="请输入董事姓名" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attendance" label="应出席股东会次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.attendance" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualAttendance" label="亲自出席股东会次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.actualAttendance" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="communicationAttendMeetings" label="通信方式参加次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.communicationAttendMeetings"
                                disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="delegateAttend" label="委托出席次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.delegateAttend" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="absence" label="出席次数">
                        <template slot-scope="scope">
                            <el-input type="number" v-model.number="scope.row.absence" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="missedTwoMeetings" label="是否连续两次未亲自参加会议">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.missedTwoMeetings" disabled>
                                <el-option key="1" label="是" value="1">
                                </el-option>
                                <el-option key="2" label="否" value="2">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="others" label="其他">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.others" disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 按会议次数计算 -->
                <el-table :data="directorateTableData2" style="width: 100%" v-if="directorateFlag == 2">
                    <el-table-column prop="meetingName" label="股东会决议名称">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.meetingName" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="directorsAttend" label="应参加董事人数">
                        <template slot-scope="scope">
                            <el-input v-model.number="scope.row.directorsAttend" disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="directorsActualAttend" label="实际出席董事人数">
                        <template slot-scope="scope">
                            <el-input v-model.number="scope.row.directorsActualAttend" disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="others" label="其他">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.others" disabled>
                                <el-option key="1" label="部分参加" value="1">
                                </el-option>
                                <el-option key="2" label="全部参加" value="2">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="originalInformation" label="原始信息">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.originalInformation" disabled></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="directorateDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <el-dialog title="董事亲属关系情况" :visible.sync="kinshipDialogVisible" width="50%">
                <el-table :data="kinshipTableData" style="width: 100%">
                    <el-table-column prop="directorName" label="董事姓名">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.directorName" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="affiliatedDirectorName" label="关联董事姓名">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.affiliatedDirectorName" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incidenceRelation" label="关联关系">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.incidenceRelation" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="originalInformation" label="原始信息录入">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.originalInformation" disabled></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="kinshipDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

        </div>
        <div class="fixed-message" v-show="type === 1">
            <div class="word-box">
                <p>{{ qusIndex }}/{{ qusLength }}<br>
                    {{ dimensionName }}</p>
            </div>
        </div>
        <span v-loading.fullscreen.lock="loading"></span>
    </div>
</template>

<script>
// import Cookies from 'js-cookie';

import {
    testPageApi
} from '../../api/api-url/testPage.js'
import store from '../../store/index';
export default {
    name: 'ViewQuestionsPage',
    components: {
    },
    data() {

        return {
            user: {},
            infoId: '',
            name: '',
            type: '',
            marginLeft: 0,
            page: 1,
            size: 10,
            nowInfo: {},
            loading: false,
            qusIndex: 0,
            qusLength: 0,
            form: {
                list: []
            },
            dimensionName: ''
        }
    },
    created() {
        this.marginLeft = (window.screen.width - 1200) / 2;
        this.infoId = this.$route.query.infoId;
        this.name = this.$route.query.name;
        this.type = this.$route.query.type;
        this.qusIndex = this.$route.query.qusIndex;
        this.qusLength = this.$route.query.qusLength;
        this.dimensionName = this.$route.query.dimensionName;
        this.getQuestionnaireInfo()
    },
    methods: {
        // // 获取用户信息和问卷信息
        // async getUserInfo() {
        //     let res = await questionApi.selectUserInfo()
        //     if (res) {
        //         // console.log(res);

        //         Cookies.set('companyName', res.result.user.companyName, {
        //             expires: 30
        //         })
        //         this.user = res.result.user;
        //     }
        // },
        toFirstPage() {
            this.$router.push({
                name: 'ViewQuestions',
            })
        },
        // 获取题目
        async getQuestionnaireInfo() {
            this.loading = true
            let res = await testPageApi.selectQuestionnaireInfo({
                infoId: this.infoId,
                name: this.name,
                type: this.type,
                page: this.page,
                size: this.size
            })
            // console.log(res.result);
            if (res.code === 1) {
                this.nowInfo = res.result.info;
                let list = res.result.data
                for (let i = 0; i < list.length; i++) {

                    if (list[i].dataSourceValue != null) {
                        let dataSourceValueList = list[i].dataSourceValue.split(',')
                        list[i].dataSourceValue = []

                        for (let k = 0; k < dataSourceValueList.length; k++) {
                            list[i].dataSourceValue.push({
                                value: dataSourceValueList[k]
                            })
                        }
                    }

                    if (list[i].calculationValue != null && list[i].calculationMethod === '5') {
                        let areaList = JSON.parse(list[i].calculationValue)
                        const areaList2 = this.recursionRemoveEmpty(areaList)
                        list[i].options = areaList2
                        list[i].answer = list[i].answer.split('/')
                    } else if (list[i].calculationValue != null) {
                        let valueList = list[i].calculationValue.split(',')
                        list[i].calculationValue = []
                        for (let j = 0; j < valueList.length; j++) {
                            list[i].calculationValue.push({
                                value: valueList[j]
                            })
                        }
                    }
                    //实控人控制层级
                    if (list[i].fourthIndicatorName === '实控人控制层级' && list[i].answer != null) {
                        if (list[i].answer === '无') {
                            this.actualControllerChecked = true
                        } else {
                            this.actualControllerTableData = JSON.parse(list[i].originalValue)
                            list[i].answer = list[i].originalValue
                        }
                    }
                    //股东大会参与度
                    if (list[i].fourthIndicatorName === '股东大会参与度' && list[i].answer != null) {
                        if (list[i].answer === '无') {
                            this.shareholderChecked = true
                        } else {
                            const shareholderTableList = JSON.parse(list[i].originalValue)
                            if (list[i].flag == 1) {
                                this.shareholderTableData = shareholderTableList
                                this.shareholderFlag = '1'
                                console.log(this.shareholderTableData);
                            } else {
                                this.shareholderFlag = '2'
                                this.shareholderTableData2 = shareholderTableList
                            }
                            list[i].answer = list[i].originalValue
                        }
                    }
                    //董事会出席情况
                    if (list[i].fourthIndicatorName === '董事会出席情况' && list[i].answer != null) {
                        if (list[i].answer === '无') {
                            this.directorateChecked = true
                        } else {
                            const directorateTableList = JSON.parse(list[i].originalValue)
                            if (list[i].flag == 1) {
                                this.directorateTableData = directorateTableList
                                this.directorateFlag = '1'
                            } else {
                                this.directorateFlag = '2'
                                this.directorateTableData2 = directorateTableList
                            }
                            list[i].answer = list[i].originalValue
                        }
                    }

                    //董事亲属关系情况
                    if (list[i].fourthIndicatorName === '董事亲属关系情况') {
                        if (list[i].answer === '无') {
                            this.kinshipChecked = true
                        } else {
                            this.kinshipTableData = JSON.parse(list[i].originalValue)
                            list[i].answer = list[i].originalValue
                        }
                    }

                }
                this.form.list = list
                this.loading = false
            }
        },

    },
    mounted() {
        store.commit('setRadio', this.type)
    }
}
</script>

<style lang="scss">
.testPage {
    overflow-x: hidden;
    background-color: #F3F5F6;
    height: 100%;

    .video {
        position: relative;
        top: -260px
    }

    .t-content {
        width: 1200px;
        background-color: #fff;
        padding-top: 20px;
        margin-bottom: -226px;
        position: relative;
        top: -260px;

        .top-title {
            text-align: center;
            font-size: 24px;
            color: #333333;
            font-weight: 700;
            margin-top: 30px;
            margin-bottom: 20px;
        }

        .top-second-title {
            font-size: 16px;
            text-align: center;
            margin-bottom: 40px;

            span {
                color: red;
            }
        }


        .question-item {
            margin: 0px 60px;

            .el-form-item {
                margin: 10px 0 0 0;
            }

            .q-i-question {
                font-size: 16px;
                //font-family: PingFang SC;
                font-weight: 400;
                color: #000000;
                line-height: 11px;

                .el-icon-info {
                    // color: #ADB0B7;
                    margin-left: 10px;
                }
            }

            .input {
                width: 354px;
            }

            .el-input__inner {
                height: 38px;
                // background: #F4F5F8;
                border-radius: 2px;
            }

            .select {
                // margin-left: 20px;
                width: 175px;
                height: 38px;
            }

            .more-input {
                margin-left: 0 !important;
                display: flex;
                justify-content: left;
                // align-items: center;
                // height: 38px;

                .input {
                    width: 354px;
                }

                .el-input__inner {
                    height: 38px;
                    // background: #F4F5F8;
                    // border-radius: 2px;
                }

                .select {
                    // margin-left: 20px;
                    width: 175px;
                    height: 38px;
                }

                .one-select {
                    margin-left: 20px;
                }

                .two-select {
                    margin-left: 20px;

                }

            }

            .des-input {
                margin-top: 20px;
            }

        }

        .bottom-btn {
            width: 120px;
            height: 48px;
            background: #FFFFFF;
            border: 1px solid #3B9395;
            border-radius: 2px;
            color: #3B9395;
        }

        .submit {
            width: 229px;
            background: #3B9395;
            color: #fff
        }

        .staging {
            background: #3B9395;
            color: #fff
        }

        .footer {
            padding-top: 40px;
            padding-bottom: 102px;
        }
    }

    .fixed-message {
        position: fixed;
        right: 120px;
        bottom: 120px;
        background-color: #fff;
        text-align: center;
        border-radius: 50%;
        font-size: 16px;
        font-weight: 400;
        color: #333333;

        .word-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 68px;
            height: 68px;
        }

        p {
            line-height: 20px;
        }
    }
}
</style>